import { useTranslation } from '@jobcost-monorepo/i18n';
import { Button, Icon } from '@jobcost-monorepo/ui';
import { ReactElement } from 'react';

interface Props {
  handleCloseForm: () => void;
}

const ReplicateFormButtons = ({ handleCloseForm }: Props): ReactElement => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-row justify-end space-x-4 pt-4 px-4">
      <Button type="button" variant="subtle" onClick={handleCloseForm}>
        <Icon iconName="cancel" className="dark:fill-white dark:stroke-white" />
        {t('form.cancel')}
      </Button>
      <Button type="submit">
        <Icon iconName="confirm" className="fill-white stroke-white" />
        {t('form.save')}
      </Button>
    </div>
  );
};

export default ReplicateFormButtons;
